const VuexTypes = Object.freeze({
  ROLES_LIST: 'ROLES_LIST',
  ROLE_UPDATE_DATA: 'ROLE_UPDATE_DATA',
  ROLE_UPDATE: 'ROLE_UPDATE',
  ROLE_CREATE_DATA: 'ROLE_CREATE_DATA',
  ROLE_CREATE: 'ROLE_CREATE',
});

export default VuexTypes;
